export const HealtCheckPage = () => {
  return (
    <button
      onClick={() => {
        throw new Error('sentry test')
      }}>
      sentry test
    </button>
  )
}
